export const lang = {
    "item1":"About",
    "item2":"Products & Services",
    "item3":"Contact",
    "intro1":"NDC (New Distribution Capability) is a new distribution standard of IATA. Airlines can provide agents with rich product information, personalized products, and complete service functions through the NDC standard.",
    "intro2":"SmartNDC is an aggregator of airlines’ NDC services, helping agents to connect with airlines’ NDCs, providing simple and rich JSON API interfaces, online booking tools, mobile booking pages, etc. It can meet the customer management and channel distribution needs of agents. Support NDC-based seat selection, luggage, VIP room, round trip, multi-trip, etc. ",    
    "title1":"Online booking tool",
    "subtitle1":"The OBT and management of airline NDC products meet the needs of customization and distribution. ",
    "title2":"Mobile booking page ",
    "subtitle2":"The adaptive mobile booking page is convenient for mobile access or embedding in mobile applications. ",    
    "title3":"Simple JSON API",
    "subtitle3":"Meet the basic booking and ticketing, and reduce the complexity of development and integration. ",
    "title4":"Rich JSON API",
    "subtitle4":"It supports all the functions of the airline's NDC and facilitates the development of various applications. ",       
    "title5":"Optional cloud service",
    "subtitle5":"Flexible and fast use, reducing deployment and operating costs. ",
    "title6":"Can be deployed locally",
    "subtitle6":"To ensure the security of private data, it can be customized and developed. ",    
    "title7":"Feature upgrades",
    "subtitle7":"Offer a free product feature upgrades for the development of the NDC. ",
    "title8":"Technical service",
    "subtitle8":"7*24 hours technical service to ensure uninterrupted operation. ",        
    "copyright":"Beijing DianDong ChuangXiang Technology Co., Ltd.", 
    "c_name":"Name*", 
    "c_email":"Email*", 
    "c_phone":"Phone*", 
    "c_message":"Message*", 
    "c_send":"Send", 
}